import img1 from "../img/home/12.png";
import img2 from "../img/home/13.png";
import img3 from "../img/home/14.png";
import img4 from "../img/home/15.png";
import img5 from "../img/home/16.png";
import img6 from "../img/home/17.png";
import img7 from "../img/home/18.png";
import img8 from "../img/home/19.png";
import img9 from "../img/home/20.png";
import img10 from "../img/home/21.png";

const ServicesData = [
    {
        id: 1,
        name: 'Manicures',
        img: img1,
        services: [
            {
                id : 1,
                name: 'Classic Manicure',
                price: '$25',
                desc: 'Nail Trimming, Shaping, cuticle cut, buffing, lotion with a 5 minute massage & finished with your choice of color',
            },
            {
                id : 2,
                name: 'Deluxe Manicure',
                price: '$35',
                desc: 'Soak, cleanse, shape your nails, trim cuticles, apply collagen gloves to soothe your skin, massage & moisturizing lotion, finish off with hot towels & polish'
            },
            {
                id : 3,
                name: 'Heavenly Manicure',
                price: '$45',
                desc: 'Immerse yourself into the ultimate experience with sea salt scrub, hydrating milk & honey butter to smooth & soften rough skin, followed by hot stones reflexology, additional massage, hands, arms'
            },
            {
                id : 4,
                name: 'Gold Manicure',
                price: '$55',
                desc: 'Indulge in the most luxurious manicure by rejuvenating & hydrating your skin with freshly cut cucumbers along with organic mask, followed by hot stones massage on hands, arms, neck & shoulders & finished with hot towels, & polish'
            },
        ],
    },
    {
        id: 2,
        name: 'Pedicure',
        img: img2,
        services: [
            {
                id : 1,
                name: 'Express Pedicure',
                price: '$38',
                desc: 'Soak, nail shaping filing, cuticle trim, buffing & polish of choice'
            },
            {
                id : 2,
                name: 'Lavender Pedicure',
                price: '$45',
                desc: 'Soak, nail shaping, filing, cuticle trim, buffing, CALLUS Removal of dead skin under the feet, heel treatment, massage, finishing up with hot towels & Polish'
            },
            {
                id : 3,
                name: 'Fresh Cucumber Pedicure',
                price: '$50',
                desc1:'10 MINUTE MASSAGE',
                desc: 'A symphony of essential oils, vitamin E, antioxidants formulated to stimulate your senses as it smooths, refines & conditions your feet. A Cucumbers rub follows to wipe dead skin & restore moisture, hot stones massage & Hot towels',
            },
            {
                id : 4,
                name: 'Fresh Aloe Vera Pedicure',
                price: '$57',
                desc1: '15 MINUTE MASSAGE',
                desc: 'Designed to moisturize, revitalize & hydrate the skin, this pedicure is full Of Vitamin E, a warm paraffin treatment seals in moisture & provides complete hydration, leaving you renewed, soften with silky smooth skin'
            },
            {
                id: 5,
                name: 'Signature Cosmo Pedicure',
                price: '$65',
                desc1: '20 MIN FOOT MASSAGE',
                desc: 'An unforgettable experience of pure pampering that softens the skin, eliminates dryness, deeply relaxes you, the pedicure begins with a foot bath, cuticle trim, extensive callus removal, & sea salt exfoliation is included to help soften rough skin, our foot mask incorporates with long Deep tissue massage, paraffin wax, hot stones & war, towels to infuse moisture providing a silky smooth skin'
            },
            {
                id: 6,
                name: 'Volcano Pedicure',
                price: '$79',
                desc: 'One of our most indulgent pedicure treatments includes a soothing soak, a purifying scrub, a nourishing mask, followed by a paraffin wax treatment, hot stone therapy, and a 20-minute deep tissue foot massage, finishing with a 5-minute shoulder massage using our rich massage cream to soften and soothe'
            },
            {
                id: 7,
                name: 'Candle Wax Gold CBD Pedicure',
                price: '$89',
                desc1: '5 minutes shoulder massage',
                desc: 'This pedicure treatment offers a calming experience, hydrating the skin to minimize dryness and remove dead skin cells. It enhances blood circulation by dilating blood vessels with warm heat from CANDLE WAX treatments. Our CEREMONY of GOLD products slow down collagen depletion, boost skin elasticity, and stimulate skin toning. The treatment includes a gold soak with herbal infused foot bath, neck therapy, and collagen foot mask, accompanied by a 25-minute massage with hot stone and paraffin wax'
            }
        ],
    },
    {
        id: 3,
        name: 'Acrylic Services',
        img: img3,
        services: [
            {
                id : 1,
                name : 'Acrylic Full set',
                price: '$50+'
            },
            {
                id : 2,
                name : 'Acrylic Fill',
                price: '$45+'
            },
        ],
    },
    {
        id: 4,
        name: 'Nex-Gen & Dipping Powder',
        img: img4,
        services: [
            {
                name: 'Dip Color',
                price : '$45',
            },
            {
                name: 'Dip French',
                price : '$55+',
            },
            {
                name: 'Dip Ombré',
                price : '$70',
            }
        ],
    },
    {
        id: 5,
        name: 'Facial',
        img: img5,
        services: [
            {
                name: 'Deep Cleansing',
                price: '$70',
                desc: "This treatment includes professional double cleansing, exfoliation, extractions, masque, hydration and solar defense. Additional products and therapies may be added to target the individual needs of your skin."
            },
            {
                name: 'Anti-Acne Facial',
                price: '$80',
                desc: "Works to treat clear and prevent adult acne while addressing the needs of adult skin. Anti-Acne Facial controls acne without compromising skin's integrity, which means skin is clearer and healthier."
            },
            {
                name: 'Marine Essential',
                price: '$80',
                desc: "Nutrient dense essentials to transform your skin. It features a complete regimen to firm, smooth and help control the signs of skin aging at the source."
            }
        ],
    },
    {
        id: 6,
        name: 'Gel Services',
        img: img6,
        services: [
            {
                id : 1,
                name: 'Hard Gel (Builder Gel)',
                price : '$60+',
            },
            {
                id : 2,
                name: 'Gel X',
                price: '$65+',
            },
            {
                id : 3,
                name: 'Gel Manicure',
                price: '$45+',
            },
            {
                id : 4,
                name: 'Gel Polish Change',
                price: '$30',
            },
        ],
        desc: ''
    },
    {
        id: 7,
        name: "Kid's Menu",
        img: img7,
        desc: '',
        services: [
            {
                name : 'Manicure',
                price : '$15'
            },
            {
                name : 'Pedicure',
                price : '$25'
            },
            {
                name: 'Polish Change Hand',
                price: '$10'
            },
            {
                name: 'Polish Change Feet',
                price: '$10'
            },
            {
                name: 'Gel Polish Hand',
                price: '$20'
            },
            {
                name: 'Gel Polish Feet',
                price: '$20'
            }
        ]
    },
    {
        id: 8,
        name: 'Waxing',
        services: [
            {
                name: 'Eyebrows',
                price: '$15'
            },
            {
                name: 'Upper Lip',
                price: '$10'
            },
            {
                name: 'Side Burns',
                price: '$10'
            },
            {
                name: 'Cheeks',
                price: '$15+'
            },
            {
                name: 'Full Face',
                price: '$45+'
            },
            {
                name: 'Chin',
                price: '$15+'
            },
            {
                name: 'Under Arms',
                price: '$25+'
            },
            {
                name: 'Full Arms',
                price: '$55+'
            },
            {
                name: 'Half Arm',
                price: '$40+'
            },
            {
                name: 'Back',
                price: '$55+'
            },
            {
                name: 'Chest',
                price: '$45+'
            },
            {
                name: 'Full Legs',
                price: '$65+'
            },
            {
                name: 'Lower Legs',
                price: '$40+'
            },
            {
                name: 'Upper Legs',
                price: '$45+'
            },
            {
                name: 'Brazilian',
                price: '$60+'
            },
            {
                name: 'Bikini',
                price: '$50+'
            }
        ],
        img: img8,
    },
    {
        id: 9,
        name: 'Eyelash Extensions',
        services: [
            {
                name : 'Eyelash Tinting',
                price : '$25',
            },
            {
                name : 'Eyebrows Tinting',
                price : '$20',
            },
            {
                name : 'Lashes',
                price : 'Market Price',
            },
            {
                name : 'Lashes Fill',
                price : 'Varies',
            }
        ],
        img: img9,
    },

    {
        id: 10,
        name: 'Extras',
        services: [
            {
                name: 'Add Gel',
                price : '$20'
            },
            {
                name : 'French Style',
                price : '$10+'
            },
            {
                name : 'Nail Shaping',
                price : '$5'
            },
            {
                name : 'Nail Extensions',
                price : '$5'
            },
            {
                name : 'Extra Length',
                price : '$5+'
            },
            {
                name : 'Cuticle Cut',
                price : '$5'
            },
            {
                name : 'Nail Repair',
                price : '$8+'
            },
            {
                name : 'Nail Designs',
                price : '$5+'
            },
            {
                name: 'Matte Nails',
                price : '$5'
            },
            {
                name: 'Toe Nails Exten',
                price: '$8'
            },
            {
                name: 'Toe Full Set',
                price: '$50'
            },
            {
                name: 'Cut Down Reshape',
                price: '$5+'
            },
            {
                name: 'Paraffin Wax Hand',
                price: '$8'
            },
            {
                name: 'Paraffin Wax Toe',
                price: '$10'
            },
            {
                name: 'Acrylic Removal',
                price: '$20+'
            },
            {
                name: 'Dip/ Gel Removal',
                price: '$15+'
            },
            {
                name: 'Gel X Removal',
                price: '$20+'
            },
            {
                name: 'Shinny Buff',
                price: '$5'
            },
            {
                name: 'Collagen Glove/Sock',
                price: '$10'
            }
        ],
        img: img10,
    }
];

export default ServicesData;